export var ActivationTypeEnum;
(function (ActivationTypeEnum) {
    ActivationTypeEnum[ActivationTypeEnum["ACTION"] = 1] = "ACTION";
    ActivationTypeEnum[ActivationTypeEnum["NO_ACTION"] = 2] = "NO_ACTION";
    ActivationTypeEnum[ActivationTypeEnum["BONUS_ACTION"] = 3] = "BONUS_ACTION";
    ActivationTypeEnum[ActivationTypeEnum["REACTION"] = 4] = "REACTION";
    ActivationTypeEnum[ActivationTypeEnum["MINUTE"] = 6] = "MINUTE";
    ActivationTypeEnum[ActivationTypeEnum["HOUR"] = 7] = "HOUR";
    ActivationTypeEnum[ActivationTypeEnum["SPECIAL"] = 8] = "SPECIAL";
})(ActivationTypeEnum || (ActivationTypeEnum = {}));
